import React, { ReactNode } from 'react';
import styles from './Button.module.css';

interface ButtonProps {
  type?: 'button' | 'submit';
  loading?: boolean;
  loadingText?: string;
  disabled?: boolean;
  onClick?: () => void;
  children: ReactNode;
}

export default function Button({
  type = 'submit',
  loading = false,
  loadingText = 'Cargando...',
  disabled = false,
  onClick,
  children,
}: ButtonProps) {
  return (
    <button type={type} className={styles.button} disabled={disabled || loading} onClick={onClick}>
      {loading ? loadingText : children}
    </button>
  );
}
